/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Test
 * test for applicants to analytics team
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Applicant
 */
export interface Applicant {
    /**
     * 
     * @type {number}
     * @memberof Applicant
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Applicant
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof Applicant
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof Applicant
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof Applicant
     */
    code: string;
}

/**
 * Check if a given object implements the Applicant interface.
 */
export function instanceOfApplicant(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "lastName" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "code" in value;

    return isInstance;
}

export function ApplicantFromJSON(json: any): Applicant {
    return ApplicantFromJSONTyped(json, false);
}

export function ApplicantFromJSONTyped(json: any, ignoreDiscriminator: boolean): Applicant {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'firstName': json['first_name'],
        'lastName': json['last_name'],
        'email': json['email'],
        'code': json['code'],
    };
}

export function ApplicantToJSON(value?: Applicant | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'first_name': value.firstName,
        'last_name': value.lastName,
        'email': value.email,
        'code': value.code,
    };
}

